[
  { "label": "Cloudflare-SIN-SG", "lat": 1.3521, "lon": 103.8198, "country": "SG" },
  { "label": "Cloudflare-NRT-JP", "lat": 35.6762, "lon": 139.6503, "country": "JP" },
  { "label": "Cloudflare-HKG-HK", "lat": 22.3193, "lon": 114.1694, "country": "HK" },
  { "label": "Cloudflare-ICN-KR", "lat": 37.5665, "lon": 126.9780, "country": "KR" },
  { "label": "Akamai-SIN-SG", "lat": 1.2900, "lon": 103.8500, "country": "SG" },
  { "label": "Fastly-TYO-JP", "lat": 35.6895, "lon": 139.6917, "country": "JP" },
  { "label": "AWS CloudFront-SIN-SG", "lat": 1.3000, "lon": 103.8000, "country": "SG" },
  { "label": "Tencent-HKG-HK", "lat": 22.2800, "lon": 114.1600, "country": "HK" }
]
